import { Tab } from '@headlessui/react';
import React from 'react';
import { isElement } from 'react-dom/test-utils';
import { composeClassName } from '@/utils/util_helpers';
import { TabsListProps } from './types';

const TabsList: React.FC<TabsListProps> = ({ children, className }) => {
  return (
    <Tab.List className={composeClassName('mb-2 mt-2 flex gap-3', className && className)}>
      {isElement(children)
        ? ({ selectedIndex }) => {
            return React.Children.map(
              children as unknown as React.ReactElement,
              (child: React.ReactElement) => {
                return {
                  ...child,
                  props: {
                    ...child.props,
                    selectedIndex,
                  },
                };
              }
            ) as unknown as React.ReactElement;
          }
        : children}
    </Tab.List>
  );
};

export { TabsList };
